import { HackleSubscriptionStatus } from "./HackleSubscriptionStatus"
import { PropertyOperationsBuilder } from "../property/PropertyOperations"
import { HackleEvent } from "../../index.browser"
import ObjectUtil from "../../core/internal/util/ObjectUtil"

export class HackleSubscriptionOperationsBuilder {
  private operations: Map<string, HackleSubscriptionStatus> = new Map()

  marketing(value: HackleSubscriptionStatus): HackleSubscriptionOperationsBuilder {
    this.operations.set("$marketing", value)
    return this
  }

  information(value: HackleSubscriptionStatus): HackleSubscriptionOperationsBuilder {
    this.operations.set("$information", value)
    return this
  }

  custom(key: string, value: HackleSubscriptionStatus): HackleSubscriptionOperationsBuilder {
    this.operations.set(key, value)
    return this
  }

  build(): HackleSubscriptionOperations {
    return new HackleSubscriptionOperations(this.operations)
  }
}

export class HackleSubscriptionOperations {
  private readonly operations: Map<string, HackleSubscriptionStatus>
  constructor(operations: Map<string, HackleSubscriptionStatus>) {
    this.operations = operations
  }

  toEvent(key: string): HackleEvent {
    const propertyOperationsBuilder = new PropertyOperationsBuilder();
    this.operations.forEach((status, key) => {
      propertyOperationsBuilder.set(key, status);
    })

    return {
      key: key,
      properties: ObjectUtil.fromMap<string>(this.operations),
    }
  }


  toRecord() {
    const object: Record<string, string> = {}
    this.operations.forEach((status, key) => {
      object[key] = status;
    })
    return object
  }
}
